import _typeof from "@babel/runtime/helpers/typeof";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Event from './Event';
import { fetchAllEvents, by_start_date_time, by_end_date_time, moveElementToEndOfArray, moveElementToStartOfArray } from '../utils';
import { setEvents } from '../actions/events';
import { setTodaysDate } from '../actions/today';
import { mapDate } from '../actions/map';
var Events = function Events(props) {
  var dispatch = useDispatch();
  var loadingEvents = useSelector(function (state) {
    return state.loadingEvents;
  });
  var events = useSelector(function (state) {
    return state.events;
  });
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  var renderEvents = [];
  var params = useParams();
  useEffect(function () {
    console.log('Welcome to Jewelry Week!');
    setInterval(function () {
      return dispatch(setTodaysDate(new Date()));
    }, 60000);
    fetchAllEvents().then(function (events) {
      // console.log('events', events)
      dispatch(setEvents(events));
    })["catch"](function (error) {
      return console.log(error);
    });
  }, []);
  if (events) {
    if (!events || _typeof(events) !== 'object') {
      renderEvents = [];
    }
    if (events && _typeof(events) === 'object') {
      console.log('is object');
      if (params.type !== 'virtual' && params.cat && events[params.cat]) {
        renderEvents = events[params.cat].filter(function (event) {
          return !event.virtual;
        });
      }
      if (params.type === 'virtual') {
        Object.keys(events).forEach(function (eventsKey) {
          console.log('events from key', events[eventsKey]);
          if (!events[eventsKey] || _typeof(events[eventsKey]) !== 'object') return;
          events[eventsKey].forEach(function (event) {
            if (event.virtual) {
              if (params.cat === 'instagram') {
                if (event.instagram) {
                  renderEvents.push(event);
                }
              } else {
                if (!event.instagram) {
                  renderEvents.push(event);
                }
              }
            }
          });
        });
      }

      // renderEvents.sort(alphabetically);
      renderEvents.sort(by_start_date_time);

      // Move events with no start time to the end
      renderEvents.forEach(function (renderEvent, i) {
        if ('date' in renderEvent && (!('start_time' in renderEvent) || renderEvent.start_time === null)) {
          renderEvents = moveElementToEndOfArray(renderEvents, i);
        }
      });

      // move joy of collecting to the top
      renderEvents.forEach(function (renderEvent, i) {
        if (renderEvent.id === 19948) {
          renderEvents = moveElementToStartOfArray(renderEvents, i);
        }
      });
    }

    // renderEvents.sort(by_end_date_time);
    // if (params.cat == 'scheduled-event' && params.type == 'ongoing') {
    //   let allScheduled = [];
    //   // console.log(Object.keys(events));
    //   // console.log(events);
    //   let allKeys = Object.keys(events);

    //   allKeys.forEach(it => {
    //     let catIndex = eventCats.findIndex(cat => {
    //       return cat.slug == it
    //     });
    //     if (catIndex < 0) {
    //       let dayEvents = events[it];
    //       dayEvents.forEach(event => {
    //         let dayEventIndex = allScheduled.findIndex(it1 => it1.id == event.id);
    //         if (dayEventIndex < 0) {
    //             allScheduled.push(event);
    //         }
    //       })
    //     }
    //   });
    //   renderEvents = allScheduled;
    // }
  }

  // console.log(events);
  var today = new Date();
  var todaysDate = selectedTestDay ? selectedTestDay : "".concat(today.getFullYear(), "-").concat(today.getMonth() + 1, "-").concat(today.getDate());
  var weekEndDate = new Date(eventIntros[eventIntros.length - 1]);
  console.log('render events count', renderEvents.length, loadingEvents);
  return /*#__PURE__*/React.createElement("div", null, loadingEvents ? /*#__PURE__*/React.createElement("div", {
    className: "event-loading-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-loading"
  }, "Loading")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "events-wrapper"
  }, renderEvents.length > 0 && params.type === 'one-time' && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'none'
    },
    id: "map-current-date"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return dispatch(mapDate());
    }
  }, "Map this date")), renderEvents.length > 0 ? renderEvents.map(function (nycjwEvent, index) {
    if (nycjwEvent.hide_from_listing) return /*#__PURE__*/React.createElement("div", {
      key: nycjwEvent.id
    });
    if (nycjwEvent.intro && (todaysDate < params.cat || today > weekEndDate)) return /*#__PURE__*/React.createElement("div", {
      key: nycjwEvent.id
    });
    return /*#__PURE__*/React.createElement(Event, {
      key: "event-".concat(index),
      nycjwEvent: nycjwEvent
    });
  }) : /*#__PURE__*/React.createElement("div", {
    className: "no-events"
  }, /*#__PURE__*/React.createElement("p", null, "No events")))));
};
export default Events;